import type { AppRouteRecordRaw } from '@/router/types'
import { useI18n } from '@/hooks/web/useI18n'
import { LAYOUT } from '@/router/constant'

const { t } = useI18n()

const EscalatorLiveRoute: AppRouteRecordRaw = {
  path: '/escalatorLive',
  name: 'EscalatorLive',
  component: LAYOUT,
  meta: {
    title: '本地扶梯监控',
    icon: 'video-camera',
    hideBreadcrumb: true,
    hideMenu: true,
    perCode: 'escalatorLive',
    orderNo: 10,
    layout: 'empty',
    master: true
  },
  children: [
    {
      path: '/escalatorLive',
      name: 'EscalatorLiveIndex',
      component: () => import('@/views/escalatorLive/index.vue'),
      meta: {
        title: '本地扶梯监控',
        hideBreadcrumb: true,
        hideMenu: true,
        master: true,
        perCode: 'escalatorLive',
        layout: 'empty'
      }
    }
  ]
}

export default EscalatorLiveRoute
